/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/prop-types */
import React, {
  useContext, createContext, useState,
} from 'react';
import { JobApplicationContextProps } from './JobApplicationContext.types';
import { JobApplicationProviderProps } from './JobApplicationProviderProps.types';
import { PositionType } from '../../types';

const JobApplicationContext = createContext<JobApplicationContextProps>(undefined!);
export function useJobApplication() {
  return useContext(JobApplicationContext);
}

export function JobApplicationProvider({ children }: JobApplicationProviderProps) {
  const [position, setPosition] = useState<PositionType | undefined>();
  const [firstName, setFirstName] = useState<string>();
  const [dateOfBirth, setDateOfBirth] = useState<string>();
  const [lastName, setLastName] = useState<string>();
  const [middleName, setMiddleName] = useState<string>();
  const [selectedGender, setSelectedGender] = useState<string>();
  const [registrationNumber, setRegistrationNumber] = useState<string>();
  const [phone1, setPhone1] = useState<string>();
  const [phone2, setPhone2] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [addressLine1, setAddressLine1] = useState<string>();
  const [addressLine2, setAddressLine2] = useState<string>();
  const [city, setCity] = useState<string>();
  const [postalCode, setPostalCode] = useState<string>();
  const [country, setCountry] = useState<string>();
  const [selectedJobTitle, setSelectedJobTitle] = useState<string>();

  return (
    <JobApplicationContext.Provider
      value={{
        addressLine1,
        addressLine2,
        city,
        country,
        dateOfBirth,
        email,
        firstName,
        lastName,
        middleName,
        phone1,
        phone2,
        position,
        postalCode,
        registrationNumber,
        selectedGender,
        selectedJobTitle,
        setAddressLine1,
        setAddressLine2,
        setCity,
        setCountry,
        setDateOfBirth,
        setEmail,
        setFirstName,
        setLastName,
        setMiddleName,
        setPhone1,
        setPhone2,
        setPosition,
        setSelectedJobTitle,
        setPostalCode,
        setRegistrationNumber,
        setSelectedGender,
      }}
    >
      {children}
    </JobApplicationContext.Provider>
  );
}
